import { render, staticRenderFns } from "./LandingSorteo2.vue?vue&type=template&id=8d2acd5c"
import script from "./LandingSorteo2.vue?vue&type=script&lang=js"
export * from "./LandingSorteo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports